module.exports = __webpack_public_path__ + "img/bau-logo-umis.4f0b4a61.png";